import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const designGalleryClassName = css({
  marginTop: 0,
});

export const loadingClassName = css({
  alignItems: 'center',
  display: 'flex',
  height: 118,
  justifyContent: 'center',
});

export const designGalleryItemClassName = css({
  background: Colors.White,
  cursor: 'pointer',
  position: 'relative',
  width: 175,
  WebkitTouchCallout: 'none',
  WebkitUserSelect: 'none',
  khtmlUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  userSelect: 'none',
});

export const overlayClassName = css({
  border: `3px solid ${Colors.Primary}`,
  borderRadius: 6,
  boxShadow: `inset 0 0 0 2px ${Colors.White}`,
  cursor: 'pointer',
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  height: '100%',
  width: '100%',
  zIndex: 2,
});

export const wrapperClassName = css({
  backgroundPosition: '50% 50%',
  backgroundRepeat: 'no-repeat',
  border: '1px solid #F0F0F0',
  borderRadius: 6,
  flex: '1 1 0%',
  overflow: 'hidden',
  paddingTop: '66.6667%',
  position: 'relative',
});

export const innerClassName = css({
  alignItems: 'center',
  display: 'flex',
  inset: 0,
  justifyContent: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  WebkitBoxPack: 'center',
  WebkitBoxAlign: 'center',
});

export const pictureClassName = css({
  height: '100%',
  width: '100%',
});

export const imageClassName = css({
  inset: 0,
  objectFit: 'cover',
  position: 'relative',
  height: '100%',
  width: '100%',
});

export const captionClassName = css({
  position: 'absolute',
  bottom: Spacing.XS,
  right: Spacing.MD,
});

export const labelClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.MEDIUM,
});

export const activeClassName = css({
  color: Colors.Primary,
});
